import { Component } from "@angular/core"
import { CommonModule } from "@angular/common"
import { RouterOutlet } from "@angular/router"

@Component({
    selector: "hs-tools",
    standalone: true,
    imports: [CommonModule, RouterOutlet],
    templateUrl: "./tools.component.html",
    styleUrls: ["./tools.component.scss"],
})
export class ToolsComponent {}
